import {ButtonSeeker, IconSeekers} from "ui-seeker/core";
import * as React from "react";
import {useContextSelector} from "use-context-selector";
import {AppCalendarEventsContext} from "../../Providers/@contexts";


export default function AppCalendarAddEventButton() {

    const updateEvents = useContextSelector(AppCalendarEventsContext, ({ updateState }) => updateState)

    return <div className="table-daily-buttons flex flex-end">
        <ButtonSeeker size="small" variant="outlined" onClick={() => updateEvents({ isOpenFormModal: true })}>
            <IconSeekers icon="calendar-check" iconType="fontAwesome" />
            <span className="mx-8">Add Event</span>
            <IconSeekers icon="plus" iconType="fontAwesome" />
        </ButtonSeeker>
    </div>
}